import { call, put, takeLatest, all } from 'redux-saga/effects';
import { showMessage } from 'app/store/actions/fuse';
import * as Actions from '../../actions';
import userService from '../../../services/userService';

function* fetchAllUsers() {
	try {
		const response = yield call(() => userService.fetchAllUsers());
		yield put(Actions.fetchAllUsersSuccess(response.data));
	} catch (error) {
		yield put(
			showMessage({
				message: 'Unable to retrieve Users' + error,
				variant: 'error'
			})
		);

		yield put(Actions.fetchAllUsersFailure());
	}
}

function* watchUsers() {
	yield all([takeLatest(Actions.fetchAllUsers, fetchAllUsers)]);
}

export default watchUsers;
